const MEASUREMENT_ID = "G-Q30CHSVBMC";
const INLOGLINK_PATH = "/account/inloglink";

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

// Every build is the same bundle (ADR-0005), so gating happens at runtime: only acc and
// production answer under `jeugdbrandweer.nl` (infra/env/{acc,prd}.tfvars).
export function initAnalytics(
  hostname: string = window.location.hostname,
  pathname: string = window.location.pathname,
): void {
  if (!hostname.endsWith(".jeugdbrandweer.nl")) {
    return;
  }

  // The inloglink's nonce and token ride in this URL, and gtag.js reports the full address.
  if (pathname.startsWith(INLOGLINK_PATH)) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(["js", new Date()]);
  window.dataLayer.push(["config", MEASUREMENT_ID]);
}
